var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookThirdParty = function SvgFacebookThirdParty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#1877F2",
    opacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.646 15.55v-.72c0-.412.206-.721.411-1.131.207-.413.619-.722 1.236-1.03.514-.308 1.337-.515 2.366-.515h2.882v3.19h-2.162c-.205 0-.411.104-.617.206-.206.205-.31.309-.31.411v1.956h2.985c0 .411-.103.72-.103 1.13l-.103.927c0 .309-.103.618-.103.926h-2.675v8.746h-3.91V20.9h-1.852v-2.984h1.955z"
  })));
};
export default SvgFacebookThirdParty;